import { render, staticRenderFns } from "./_move_attachments_modal.vue?vue&type=template&id=e95e34c0&"
import script from "./_move_attachments_modal.vue?vue&type=script&lang=js&"
export * from "./_move_attachments_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports